import React, { useEffect, useContext, useRef, useId } from 'react';
import 'twin.macro';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../context';
import { SearchIcon } from 'icons';
import { Input } from './FormParticals';
import { gaEvent } from 'services/ga';
import { scrollToTop } from '../../lib/helpers';

export const SearchForm = ({ focused = false, setOpen = null }) => {
  const navigate = useNavigate();
  const id = useId();
  const inputRef = useRef();
  const { slideIn, setSlideIn } = useContext(AppContext);

  const searchSubmit = (value) => {
    if (value !== '') {
      gaEvent('dmp_actions', 'search');
      setSlideIn({ ...slideIn, active: false, fullwidth: false });
      scrollToTop();
      navigate(`/zoek/${encodeURIComponent(value)}`, { replace: true });
      if (setOpen !== null) {
        setOpen(false);
      }
      inputRef.current.blur();
    }
  };

  const onKeyUp = (event) => {
    if (event.charCode === 13) {
      searchSubmit(event.target.value);
    }
  };

  useEffect(() => {
    if (focused) {
      inputRef.current.focus();
    }
  }, [focused]);

  return (
    <div tw='w-full'>
      <Input
        ref={inputRef}
        placeholder='Vul zoekterm in'
        IconType={SearchIcon}
        tw='!mb-0 flex-grow'
        onKeyPress={onKeyUp}
        id={id}
        iconClick={() => {
          searchSubmit(inputRef.current.value);
        }}
      />
    </div>
  );
};
